import { render, staticRenderFns } from "./UrunSatisFiyat.vue?vue&type=template&id=3b2108b8&scoped=true"
import script from "./UrunSatisFiyat.vue?vue&type=script&lang=js"
export * from "./UrunSatisFiyat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b2108b8",
  null
  
)

export default component.exports